<div [formGroup]="formGroup">
  <mat-selection-list [formControlName]="control.name" [hideSingleSelectionIndicator]="true">
    @for (option of control.keyPairValueItems; track option) {
      <mat-list-option checkboxPosition="before" [value]="option.key">
        {{option.value}}
      </mat-list-option>
    }
  </mat-selection-list>
</div>